import { render, staticRenderFns } from "./FrondEnd.vue?vue&type=template&id=34836496&"
import script from "./FrondEnd.vue?vue&type=script&lang=js&"
export * from "./FrondEnd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports